/* ==========================================================================
   Sondur — Free Gifts presentation redesign  (namespace: sdfg)
   Native port of the injected A/B variant (travel-cushion / travel-cushion-bogo).

   Renders the free gifts inside every Kaching bundle option. The list expands
   only while that option is selected — that part is pure CSS reacting to
   Kaching's own `.kaching-bundles__bar--selected` class, so there is no JS
   state to keep in sync and re-renders cost nothing.

   Config comes from `window.SondurFreeGifts`, printed by
   snippets/sondur-free-gifts.liquid:
     { currencySymbol: "$", gifts: [{ name, value, image }, ...] }

   Styles: assets/sondur-free-gifts.css
   ========================================================================== */
(function () {
  'use strict';

  var NS = 'sdfg';
  if (window.__sdfgLoaded) return;
  window.__sdfgLoaded = true;

  var CFG = window.SondurFreeGifts || {};
  var GIFTS = CFG.gifts || [];
  var CUR = CFG.currencySymbol || '$';
  if (!GIFTS.length) return;

  var T0 = Date.now();
  var mounted = false;

  /* Never mutate inside the Replo root before React hydration finishes:
     foreign nodes get positionally adopted, which duplicates or reparents the
     whole page. Gate on a React fiber expando, with a readyState fallback. */
  function hydrated() {
    var root = document.getElementById('replo-fullpage-element');
    if (!root) return true; // no Replo on this page
    var probe = root.querySelector('[data-add-to-cart-btn]') || root.querySelector('[data-rid]');
    if (probe) {
      for (var k in probe) {
        if (k.indexOf('__reactFiber$') === 0) return true;
      }
    }
    return document.readyState === 'complete' && Date.now() - T0 > 4000;
  }

  /* Works with both bundle pickers: the old Kaching widget and the native
     sdb picker (sondur-bundles.js) that replaces it. */
  var BAR = '.kaching-bundles__bar, .sdb__bar';

  /* The main bundle widget = a picker that has bars and is not inside
     a fixed/sticky mirror (the collapsed sticky ATC bar carries a copy). */
  function mainWidget() {
    var all = document.querySelectorAll('kaching-bundle, .sdb[data-sdb]');
    var fallback = null;
    for (var i = 0; i < all.length; i++) {
      if (!all[i].querySelector(BAR)) continue;
      var fixed = false;
      var el = all[i];
      while (el && el !== document.body) {
        var cs;
        try {
          cs = getComputedStyle(el);
        } catch (e) {
          break;
        }
        if (cs.position === 'fixed' || cs.position === 'sticky') {
          fixed = true;
          break;
        }
        el = el.parentElement;
      }
      if (!fixed) return all[i];
      if (!fallback) fallback = all[i];
    }
    return fallback;
  }

  /* Cushions per option, read off the bar title:
     "Buy 1 Get 1 Free" -> 2, "2x Travel Cushions" / "2x Travel Cushion" -> 2. */
  function cushions(bar, i, count) {
    var q = parseInt(bar.getAttribute('data-sdb-qty'), 10);
    if (q > 0) return q;
    var t = bar.querySelector('.kaching-bundles__bar-title');
    t = t ? t.textContent : '';
    var m = t.match(/buy\s*(\d+)\s*get\s*(\d+)/i);
    if (m) return parseInt(m[1], 10) + parseInt(m[2], 10);
    m = t.match(/^\s*(\d+)\s*[x×]?\s/);
    if (m) return parseInt(m[1], 10);
    return count === 3 ? [1, 2, 4][i] || 1 : i + 1;
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function rowHTML(g, k) {
    var name = esc(g.name);
    return (
      '<div class="sdfg-row">' +
      '<div class="sdfg-tile"><img alt="' + name + '" src="' + esc(g.image) + '"></div>' +
      '<div class="sdfg-name">+ FREE ' + name +
      (k > 1 ? '<span class="sdfg-x">×' + k + '</span>' : '') +
      '</div>' +
      '<div class="sdfg-val">' +
      '<span class="sdfg-was">' + CUR + g.value * k + '</span>' +
      '<span class="sdfg-now">' + CUR + '0</span>' +
      '</div>' +
      '</div>'
    );
  }

  function apply() {
    if (!hydrated()) return;
    var kb = mainWidget();
    if (!kb) return;
    var bars = kb.querySelectorAll(BAR);
    if (!bars.length) return;

    var done = 0;
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      if (bar.querySelector('[data-' + NS + ']')) {
        done++;
        continue;
      }
      var host =
        bar.querySelector('.kaching-bundles__bar-wrapper, .sdb__body') ||
        bar.querySelector('.kaching-bundles__bar-container, .sdb__card');
      if (!host) continue;

      var k = cushions(bar, i, bars.length);
      var el = document.createElement('div');
      el.className = 'sdfg-gifts';
      el.setAttribute('data-' + NS, '');
      var rows = '';
      for (var g = 0; g < GIFTS.length; g++) rows += rowHTML(GIFTS[g], k);
      el.innerHTML = '<div class="sdfg-in"><div class="sdfg-pad"><div class="sdfg-hr"></div>' + rows + '</div></div>';
      try {
        host.appendChild(el);
        done++;
      } catch (e) {
        /* fail soft; the observer retries */
      }
    }

    if (done > 0) mounted = true;
    if (done === bars.length && done > 0) document.documentElement.classList.add(NS + '-on');
  }

  function tick() {
    try {
      apply();
    } catch (e) {
      /* never break the page */
    }
  }

  tick();

  var tries = 0;
  var retry = setInterval(function () {
    tick();
    if (++tries > 60) {
      clearInterval(retry);
      /* Nothing mounted in 15s — Kaching never rendered. Put the theme's own
         gift blocks back rather than leaving the page with no gift messaging.
         (The stylesheet hides them only while this class is absent.) */
      if (!mounted) document.documentElement.classList.add(NS + '-fallback');
    }
  }, 250);

  var scheduled = false;
  var mo = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      tick();
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
